export default __webpack_public_path__ + "static/media/image.2f9af082.png";